import { neutralLight, primaryLight } from '@crehana/tailwindcss/colors';
// biome-ignore lint/style/noRestrictedImports: legacy code - style/noRestrictedImports
import styled from 'styled-components';

export const Container = styled.section`
  display: flex;
  justify-content: flex-start;
  flex-grow: 1;
  @media (max-width: 768px) {
    justify-content: center;
    margin-top: 28px;
    order: 2;
  }
`;

export const Circle = styled.div<{ active: boolean }>`
  width: 28px;
  height: 28px;
  border-radius: 50%;
  color: ${({ active }) =>
    active ? primaryLight['500'] : neutralLight['700']};
  background-color: ${({ active }) =>
    active ? primaryLight['100'] : neutralLight['100']};
  border: 1px solid
    ${({ active }) => (active ? primaryLight['500'] : neutralLight['500'])};
  margin-right: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StepName = styled.span<{ active: boolean }>`
  display: ${({ active }) => (active ? 'block' : 'none')};
  color: ${neutralLight['700']};
  margin: ${({ active }) => (active ? '0px 12px 0px 0px' : '0px')};
  @media (max-width: 1024px) {
    display: none;
  }
`;

export const Divider = styled.div`
  width: 32px;
  height: 1px;
  background-color: ${neutralLight['600']};
`;
